
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy-crypto",
      function () {
        return require("private-next-pages/buy-crypto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy-crypto"])
      });
    }
  